module.exports = __webpack_public_path__ + "img/bankunverifi.3c0910b8.svg";